import { render } from "./PayAudioLibraryShell.vue?vue&type=template&id=0307ece1&scoped=true"
import script from "./PayAudioLibraryShell.vue?vue&type=script&lang=js"
export * from "./PayAudioLibraryShell.vue?vue&type=script&lang=js"

import "./PayAudioLibraryShell.vue?vue&type=style&index=0&id=0307ece1&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0307ece1"]])

export default __exports__